import React from 'react';
import { useFormikContext, ErrorMessage } from 'formik';
import {
  FormControl,
  FormLabel,
  Input,
  VStack,
  FormErrorMessage,
} from '@chakra-ui/react';

const SparkPost = () => {
  const { errors, touched, values, setFieldValue } = useFormikContext();

  return (
    <VStack spacing={4} alignItems="flex-start">
      <FormControl isInvalid={errors.credentials?.name && touched.credentials?.name}>
        <FormLabel>Name</FormLabel>
        <Input
          placeholder="Enter configuration name"
          value={values.credentials?.name || ''}
          onChange={(e) => setFieldValue('credentials.name', e.target.value)}
        />
        <ErrorMessage name="credentials.name" component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.credentials?.apiKey && touched.credentials?.apiKey}>
        <FormLabel>API Key</FormLabel>
        <Input
          placeholder="Enter your SparkPost API key"
          value={values.credentials?.apiKey || ''}
          onChange={(e) => setFieldValue('credentials.apiKey', e.target.value)}
        />
        <ErrorMessage name="credentials.apiKey" component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.credentials?.from && touched.credentials?.from}>
        <FormLabel>From Email</FormLabel>
        <Input
          placeholder="no-reply@yourdomain.com"
          value={values.credentials?.from || ''}
          onChange={(e) => setFieldValue('credentials.from', e.target.value)}
        />
        <ErrorMessage name="credentials.from" component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.credentials?.replyTo && touched.credentials?.replyTo}>
        <FormLabel>Reply To</FormLabel>
        <Input
          placeholder="replies@yourdomain.com"
          value={values.credentials?.replyTo || ''}
          onChange={(e) => setFieldValue('credentials.replyTo', e.target.value)}
        />
        <ErrorMessage name="credentials.replyTo" component={FormErrorMessage} />
      </FormControl>
    </VStack>
  );
};

export default SparkPost;